namespace Gamification.Gamification {
    export interface ProdottiEsperienzePunteggiRow {
        UserId?: number;
        TenantId?: number;
        IdProdottoEsperienzaPunteggio?: number;
        IdProdottoEsperienza?: number;
        IdentifierPunteggio?: string;
        Nome?: string;
        Descrizione?: string;
        ValoreIniziale?: number;
        ValoreNegativo?: number;
        IdProdottoEsperienzaIdProdotto?: number;
        IdProdottoEsperienzaIdentifierEsperienza?: string;
        IdProdottoEsperienzaNome?: string;
        IdProdottoEsperienzaDescrizione?: string;
        IdProdottoEsperienzaValoreIniziale?: number;
        IdProdottoEsperienzaBozza?: number;
    }

    export namespace ProdottiEsperienzePunteggiRow {
        export const idProperty = 'IdProdottoEsperienzaPunteggio';
        export const nameProperty = 'Nome';
        export const localTextPrefix = 'Gamification.ProdottiEsperienzePunteggi';
        export const deletePermission = 'Gamification:Prodotti';
        export const insertPermission = 'Gamification:Prodotti';
        export const readPermission = 'Gamification:Prodotti';
        export const updatePermission = 'Gamification:Prodotti';

        export declare const enum Fields {
            UserId = "UserId",
            TenantId = "TenantId",
            IdProdottoEsperienzaPunteggio = "IdProdottoEsperienzaPunteggio",
            IdProdottoEsperienza = "IdProdottoEsperienza",
            IdentifierPunteggio = "IdentifierPunteggio",
            Nome = "Nome",
            Descrizione = "Descrizione",
            ValoreIniziale = "ValoreIniziale",
            ValoreNegativo = "ValoreNegativo",
            IdProdottoEsperienzaIdProdotto = "IdProdottoEsperienzaIdProdotto",
            IdProdottoEsperienzaIdentifierEsperienza = "IdProdottoEsperienzaIdentifierEsperienza",
            IdProdottoEsperienzaNome = "IdProdottoEsperienzaNome",
            IdProdottoEsperienzaDescrizione = "IdProdottoEsperienzaDescrizione",
            IdProdottoEsperienzaValoreIniziale = "IdProdottoEsperienzaValoreIniziale",
            IdProdottoEsperienzaBozza = "IdProdottoEsperienzaBozza"
        }
    }
}
